// extracted by mini-css-extract-plugin
export default {"rippleContainer":"RippleEffect_rippleContainer__Dwyhs","ripple":"RippleEffect_ripple__Mbz8j","ripple-animation":"RippleEffect_ripple-animation__g-Iih"};